(function () {
  const outingPlayersAddTbdApp = function () {
    $('.add-tbd-player').on('click', function() {
      const container = $(this).parent().parent().parent();
      container.find('input[name*="first_name"]').val('TBD');
      container.find('input[name*="last_name"]').val('TBD');
      container.find('input[name*="phone"]').val('');
      container.find('input[name*="email"]').val('');
      container.find('select[name*="gender"]').val('male').trigger('change');
    });
  };

  if (typeof window !== "undefined") {
    window.outingPlayersAddTbdApp = outingPlayersAddTbdApp;
  }
})();
